const handleErr = err => console.error(err);

function countElements(cp) {
    let counter = 0;
    counter += cp.levels.length;
    counter += cp.levels.reduce( (indCount,level) => indCount + level.indicators.length ,0 );
    return counter;
}

function createIds(count, store) {
    const promises = [];
    for(let i = 0; i < count; i++) {
        promises.push(store.firestore.add('temp',{name:'temp'}));
    }
    return Promise.all(promises);
}

function pluckIds(items) {
    return items.map(item => item.id);
}

function assignElementIds(ids,cp) {
    let i = 0;
    cp.levels.map( level => {
        level.id = ids[i++];
        level.indicators.map( indicator => {
            indicator.id = ids[i++];
            return indicator;
        });
        return level;
    });
    return cp;
}



const updateCpIds = (id,store) => {
    let cp = {};
    return store.firestore
        .get({ collection:'competencies', doc: id}) 
        .then( result => result.data() )
        .then(data => {
            cp = data;
            console.log(cp.name)
            const count = countElements(cp);
            return createIds(count, store)
        })        
        .then(pluckIds)
        .then(ids => assignElementIds(ids, cp) )
        .then(data => store.firestore.update('competencies/' + id,data) ) //store.collection('competencies').doc(id).update(data))
        .catch(handleErr);
}

export default updateCpIds


// WEBPACK FOOTER //
// ./src/admin/services/update-cp-ids.js